import { createStorageValue } from '@interhyp/platform-storage';
import { createValue } from '@interhyp/platform-value';
import { z } from 'zod';
import { mortgageIntentNamespace } from '../namespaces';
const typeSchema = z.union([
    z.literal('Wohnung'),
    z.literal('EFH'),
    z.literal('DHH'),
    z.literal('ZFH'),
    z.literal('REH'),
    z.literal('RMH'),
    z.literal('MFH'),
    z.literal('Grund'), // land
]);
export const estateTypeStorageValue = createStorageValue({
    namespace: mortgageIntentNamespace,
    id: Symbol('estateType'),
    schema: typeSchema,
    type: 'local',
});
export const estateTypeMemoryValue = createValue({
    namespace: mortgageIntentNamespace,
    id: Symbol('estateTypeMemory'),
    schema: typeSchema,
});
const utilizationSchema = z.union([
    z.literal('eigen'),
    z.literal('misch'),
    z.literal('fremd'), // rent out
]);
export const estateUtilizationStorageValue = createStorageValue({
    namespace: mortgageIntentNamespace,
    id: Symbol('estateUtilization'),
    schema: utilizationSchema,
    type: 'local',
});
export const estateUtilizationMemoryValue = createValue({
    namespace: mortgageIntentNamespace,
    id: Symbol('estateUtilizationMemory'),
    schema: utilizationSchema,
});
const searchStatusSchema = z.union([
    z.literal('planning'),
    z.literal('not_visited'),
    z.literal('visited'),
    z.literal('land_visited'),
    z.literal('negotiations'),
]);
export const searchStatusStorageValue = createStorageValue({
    namespace: mortgageIntentNamespace,
    id: Symbol('searchStatusUtilization'),
    schema: searchStatusSchema,
    type: 'local',
});
export const searchStatusMemoryValue = createValue({
    namespace: mortgageIntentNamespace,
    id: Symbol('searchStatusMemory'),
    schema: searchStatusSchema,
});
const locationSchema = z.object({
    zip: z.string().min(5).max(5).optional(),
    city: z.string().optional(),
    name: z.string(),
});
export const estateLocationStorageValue = createStorageValue({
    namespace: mortgageIntentNamespace,
    id: Symbol('estateLocation'),
    schema: locationSchema,
    type: 'local',
});
export const estateLocationMemoryValue = createValue({
    namespace: mortgageIntentNamespace,
    id: Symbol('estateLocationMemory'),
    schema: locationSchema,
});
export const brokerCostsInPercentStorageValue = createStorageValue({
    namespace: mortgageIntentNamespace,
    id: Symbol('brokerCostsInPercent'),
    schema: z.number(),
    type: 'local',
});
export const brokerCostsInPercentMemoryValue = createValue({
    namespace: mortgageIntentNamespace,
    id: Symbol('brokerCostsInPercentMemory'),
    schema: z.number(),
});
